import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import styles from './ImpersonationLabel.module.scss';

const ImpersonationLabel: FC = () => {
  const [t] = useTranslation('common');
  return (
    <div className={styles.root}>
      {t('impersonate-session--label')}
    </div>
  );
};

export default ImpersonationLabel;
